import { withInstall } from '@vuesax-plus/utils'
import Input from './src/input.vue'

export const VsInput = withInstall(Input)
export default VsInput

export * from './src/input'
